import Request from "./index";

class api {
  // 获取教师所授课堂列表（分页）
  static getTeacherLessonPage(data) {
    return Request.get(`/ai_class/teacher_lesson/lesson_page`, {
      params: data
    });
  }
}

export default api;